import Head from 'next/head';
import { Box, Container, Tab, Card, Typography, Button } from '@mui/material';
import { ItemListResults } from '../list/list-results';
import { DashboardLayout } from '../dashboard-layout';
import {useState, useEffect} from 'react';

import {getLocations} from '../Utils';

import {useAuth} from "../../contexts/AuthContext"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { debugL } from '../../custom';
const db = app.firestore();

// ----------------------------------------


const LocationListTop = ({setLastRefreshDate, ...rest}) => {

  const history = useHistory()

  return (
    <Box {...rest}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          m: -1
        }}
      >
        <Typography
          sx={{ m: 1 }}
          variant="h4"
          flexGrow={1}
        >
          Boutiques
        </Typography>
        {/* <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setLastRefreshDate(new Date())}
          >
            Rafraichir
          </Button>
        </Box> */}
        <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push("/locations/add")}
          >
            Ajouter
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const attributes = {
  "Nom" : "name",
  "Contact": "contactName",
  "Adresse": "address",
  "Téléphone": "phoneNumber",
}

function LocationsGroupTable({emptyTitle, selectable, items, setItems, loading, setLoading, retailerId, ...rest}) {
  const history = useHistory();

  const { currentUser } = useAuth();

  const moveItem = async (id, up) => {
    debugL > 0 && console.log("swapItems called");    
    const filteredItems = items.filter(item => item.id == id);
    const item = filteredItems.length > 0 ? filteredItems[0] : null;

    if(item == null || up == null || (up && item.position == 0) || (!up && item.position == items.length-1) ) {
      return;
    }

    try {
      setLoading(true);

      const position = item.position
      const otherPosition = position + (up ? -1 : 1);
      const otherItem = items[otherPosition];

      await db.collection("locations").doc(item.id).update({position: otherPosition, updatedBy: currentUser.email});
      await db.collection("locations").doc(otherItem.id).update({position: position, updatedBy: currentUser.email});

      item.position = otherPosition;
      otherItem.position = position;

      const newItems = items.slice();

      newItems[position] = otherItem;
      newItems[otherPosition] = item;

      debugL > 0 && console.log("after swapping newItems");
      debugL > 0 && console.log(newItems);

      setItems(newItems);
      setLoading(false);
    } catch(e) {
      debugL > 0 && console.log("error while swapping items");
      debugL > 0 && console.log(e.message);
    } finally {
      setLoading(false);
    }
  }

  const bulkActions = [
    {
      title: "Supprimer",
      iconName: "eva:trash-2-outline",
      handler: async (ids) => {
        debugL > 0 && console.log("Supprimer"); 
        debugL > 0 && console.log(ids);
        for(let id of ids) {
          await db.collection("locations").doc(id).update({deleted: true, updatedBy: currentUser.email});
        }  
        history.go("/locations");
      }
    }
  ];
  
  let itemActions = [];
  
  if(retailerId != "loberz.com") {
    itemActions = [
      {
        title: "Modifier",
        iconName: "eva:edit-outline",
        handler: (id) => history.push("/locations/edit/"+id)
      },
      {
        title: "Déplacer haut",
        iconName: "ic:round-arrow-upward",
        handler: (id) => moveItem(id, true)
      },
      {
        title: "Déplacer bas",
        iconName: "ic:round-arrow-downward",
        handler: (id) => moveItem(id, false)
      },
    ];
  } 

  const itemsById = {};

  for(let item of items) {
    itemsById[item.id] = item;
  }

  return (
    <ItemListResults
      items={items}
      attributes={attributes}
      bulkActions={bulkActions}
      itemActions={itemActions}
      isProcessing={loading}
      filterFields={["name", "contactName", "address"]}
      selectable={selectable}
    />
  );
}

function LocationsFullPanel({lastRefreshDate}) {
  const { retailerId, currentUser } = useAuth();
  console.log("LocationsFullPanel retailerId : " + retailerId);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true); // todo handle loading.  

  const [value, setValue] = useState('1');

  const loadItems = async () => {
    debugL > 0 && console.log("loadItems called");
    try {
      const newItems = await getLocations(retailerId);
      debugL > 0 && console.log(newItems);      
      for(let i = 0 ; i < newItems.length; i++) {
        let item = newItems[i];
        if(!item.position || item.position != i) {
          await db.collection("locations").doc(item.id).update({position: i, updatedBy: currentUser.email});
          item.position = i;
        }
      }
      debugL > 0 && console.log(newItems);
      setItems(newItems);
    } catch(e) {
      debugL > 0 && console.log("error while loading items");
      debugL > 0 && console.log(e.message);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadItems();
  }, [retailerId, lastRefreshDate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card>
      {/* <Typography>{lastRefreshDate.toString()}</Typography> */}
      <Box sx={{ width: '100%', typography: 'body1' }}>        
        <LocationsGroupTable
          emptyTitle="Aucune boutique n'est enregistrée."
          items={items}
          setItems={setItems}
          loading={loading}
          setLoading={setLoading}
          selectable={true}
          retailerId={retailerId}
        />
      </Box>
    </Card>
  );
}

const Locations = () => {
  const [lastRefreshDate, setLastRefreshDate] = useState(new Date());
  
  return (  
    <>
      <Head>
        <title>
          Boutiques
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <LocationListTop setLastRefreshDate={setLastRefreshDate} />
          <Box sx={{ mt: 3 }}>
            <LocationsFullPanel lastRefreshDate={lastRefreshDate} />
          </Box>
        </Container>
      </Box>
    </>
  );
}

Locations.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default Locations;
